import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Key } from 'lucide-react';
export function RAMSystemSection() {
  return <section className="py-24 bg-slate-800 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-181">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-182"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-slate-900 border-2 border-amber-500/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-184">
          <div className="flex justify-center mb-8" data-id="element-185">
            <div className="bg-amber-500/20 p-4 rounded-full" data-id="element-186">
              <Zap className="w-12 h-12 text-amber-500" data-id="element-187" />
            </div>
          </div>

          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-center text-white uppercase mb-8" data-id="element-188">
            El Sistema <span className="text-amber-500" data-id="element-189">RAM</span>
            <br data-id="element-190" />
            <span className="text-2xl md:text-3xl text-slate-400 tracking-normal" data-id="element-191">
              (Reconocimiento de Alerta Máxima)
            </span>
          </h2>

          <div className="prose prose-lg prose-invert mx-auto" data-id="element-192">
            <p className="text-xl text-slate-300 leading-relaxed text-center mb-8" data-id="element-193">
              Este método ignora la gramática y se enfoca en{' '}
              <strong className="text-amber-400" data-id="element-194">"Palabras Gatillo"</strong>.
            </p>

            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 flex items-start gap-4 mb-6" data-id="element-195">
              <Key className="w-8 h-8 text-amber-500 flex-shrink-0 mt-1" data-id="element-196" />
              <p className="text-slate-300 m-0" data-id="element-197">
                Te enseñamos a identificar visualmente los términos técnicos en
                inglés que activan la respuesta correcta de inmediato. Es como
                tener una llave maestra para la base de datos de preguntas del
                DMV.
              </p>
            </div>

            <div className="text-center p-6 bg-emerald-500/10 border border-emerald-500/30 rounded-xl" data-id="element-198">
              <p className="text-2xl font-oswald text-emerald-400 m-0 uppercase tracking-wide" data-id="element-199">
                Si ves la palabra "A", la respuesta es siempre "B".
                <br data-id="element-200" /> Así de simple.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}